import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { getScriptStatusRequest } from '../../../../../store/actions/script';
import { statuses } from '../../../../../utils/data/data';
import classes from './tabs.module.scss';
import Loader from '../../../../_common/Loader/Loader';

const Status = () => {
  const dispatch = useDispatch();
  const { requestStatus, scriptStatuses } = useSelector((store) => store.script);
  const { scriptId } = useParams();

  useEffect(() => {
    dispatch(getScriptStatusRequest({ ScriptId: scriptId }));
  }, []);

  return (
    requestStatus === 'request'
      ? (
        <div className={classes.status_loader}>
          <Loader />
        </div>
      )

      : (
        <div className={classes.script_status_wrapper}>
          {requestStatus === 'success' && (
            <>
              {!scriptStatuses.length
                ? <div className={classes.notResult}>No Data Found</div>

                : scriptStatuses.map((s) => {
                  const isStatusChanged = !s.fromProcessedOn;
                  const fromStatus = statuses.find(({ name }) => name === s.fromStatus);
                  const toStatus = statuses.find(({ name }) => name === s.toStatus);

                  return (
                    <div key={s.id}>
                      <div className={classes.status_header}>
                        <span>{s.User.name}</span>

                        <span>
                          {moment.utc(s.createdAt).local().format('MM/DD/YYYY  LT')}
                        </span>
                      </div>

                      <div className={classes.status_text}>
                        <div>
                          {s.toStatus && !s.fromStatus
                            ? 'This script was created and marked Received'
                            : isStatusChanged
                              ? `This script has been ${s.manuallyChanged ? 'manually' : ''} changed from`
                              : `Processed On has been ${s.manuallyChanged ? 'manually' : ''} changed from`}
                        </div>

                        {(s.toStatus && !s.fromStatus)
                          ? null
                          : (
                            <>
                              <div className={classes.status_name}>
                                {isStatusChanged
                                  ? (
                                    <>
                                      {fromStatus?.icon}

                                      <span>
                                        {fromStatus?.name}
                                      </span>
                                    </>
                                  )
                                  : moment(s.fromProcessedOn)
                                    .format('MM/DD/YYYY')}
                              </div>

                              <div>to</div>

                              <div className={classes.status_name}>
                                {isStatusChanged
                                  ? (
                                    <>
                                      {toStatus?.icon}

                                      <span>
                                        {toStatus?.name}
                                      </span>
                                    </>
                                  )

                                  : moment(s.toProcessedOn)
                                    .format('MM/DD/YYYY')}
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  );
                })}
            </>
          )}
        </div>
      )
  );
};

export default Status;
